import {
  faAngleUp,
  faCode,
  faDesktop,
  faMicrophone,
  faMicrophoneAltSlash,
  faPencil,
  faPhone,
  faVideo,
  faVideoSlash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, {useCallback} from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const FooterItem = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70px;
  background-color: #191919;
  z-index: 1;
  color: #eeee;

  .left-item {
    display: flex;
    align-items: center;
    height: 100%;

    .icon-block {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      padding: 0 20px;
    }
    .icon {
      font-size: 20px;
      margin-left: 5px;
    }
    &:hover {
      background-color: #333;
    }
  }

  .center-item {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;

    .icon-block {
      background-color: #423F3E;
      border: 1px solid #161616;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 10px;

      .icon {
        font-size: 20px;
        color: #EDEDED;
      }
      &:hover {
        cursor: pointer;
        box-shadow: 0 0 15px #555;
      }
    }

    .red {
      color: #890f0d;
    }
    .red-bg {
      background-color: #c74b50;
      color: #e8e19e;
    }
  }

  .right-item {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 100%;

    .icon-block {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      height: 100%;
      width: 100px;
      text-decoration: none;
      color: #eeee;
      .icon {
        font-size: 20px;
        margin-bottom: 10px;
      }
      .title {
        margin: 0;
        font-size: 12px;
      }
      &:hover {
        cursor: pointer;
        background-color: #333;
      }
    }
  }
`;

const IconBlock = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  width: 100px;
  text-decoration: none;
  color: #eeee;
  .icon {
    font-size: 20px;
    margin-bottom: 10px;
  }
  .title {
    margin: 0;
    font-size: 12px;
  }
  &:hover {
    cursor: pointer;
    background-color: #333;
  }
`;

const CallPageFooter = (
  toggleCameraAudio,
  userVideoAudio,
  setShowVideoDevices,
) => {
  const handleToggle = useCallback(
    (e) => {
      setShowVideoDevices((state) => !state);
    },
    [setShowVideoDevices]
  );

  function Player({ srcBlob, audio }) {
    if (!srcBlob) {
      return null;
    }

    if (audio) {
      return <audio src={URL.createObjectURL(srcBlob)} controls />;
    }

    return (
      <video
        src={URL.createObjectURL(srcBlob)}
        width={520}
        height={480}
        controls
      />
    );
  }
  return (
    <FooterItem>
      <div className="left-item">
        <div className="icon-block">
          Meeting Details
          <FontAwesomeIcon className="icon" icon={faAngleUp} />
        </div>
      </div>

      <div className="center-item">
        <div className="icon-block">
          <FontAwesomeIcon className="icon" icon={faMicrophone} />
        </div>
        <div className="icon-block">
          <FontAwesomeIcon className="icon red" icon={faPhone} />
        </div>
        <div className="icon-block" >
          <div onClick={toggleCameraAudio} data-switch="video" >
            {userVideoAudio.video ? (
              <FontAwesomeIcon className="icon" icon={faVideo} />):(
              <FontAwesomeIcon className="icon" icon={faVideoSlash} />)
              }
          </div>
        </div>
      </div>

      <div className="right-item">
        <IconBlock to="/whiteboard">
          <FontAwesomeIcon className="icon red" icon={faPencil} />
          <p className="title">White Board</p>
        </IconBlock>

        <div className="icon-block">
          <FontAwesomeIcon className="icon red" icon={faDesktop} />
          <p className="title">Present Screen</p>
        </div>
        <IconBlock to="/code">
          <FontAwesomeIcon className="icon red" icon={faCode} />
          <p className="title">Start Scripting</p>
        </IconBlock>
      </div>
    </FooterItem>
  );
};

export default CallPageFooter;
